import React from "react";
import Navbar from "./components/NavBar";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";
import WebSites from "./components/Websites";

function App() {
  return (
    <div className="bg-black">
      <Navbar />
      <Hero />
      <About />
      {/* <div class="w-full flex justify-center items-center px-3 mt-10">
        <div
          class="relative w-full max-w-4xl aspect-video rounded-lg shadow-2xl overflow-hidden"
        >
          <iframe
            src="https://web-video-player2.vercel.app/sample.mp4"
            class="absolute inset-0 w-full h-full border-none"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            webkitallowfullscreen
        >
        </iframe>
        </div>
      </div> */}
      <Projects />
      <WebSites />
      <Skills />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
